<template>
  <v-container fluid>
    <ForgotPassword
      @sendEmailToUser="sendEmailToUser"
      :type="currentDataType"
      @sendNewPassword="resetNewPassword"
      @goToLogin="goToLogin"
    />
  </v-container>
</template>
<script>
import VueRouter from "vue-router";
import ForgotPassword from "@components/ForgotPassword/ForgotPassword.vue";
import { resetUserPassword, sendNewPasswordData, signupWithToken } from "@/api";
export default {
  name: "ForgotPasswordVue",
  components: {
    ForgotPassword,
  },
  data() {
    return {
      currentDataType: "forgot_password",
    };
  },
  mounted() {
    if (
      (this.$route.path == "/setup/password" || this.$route.path == "/reset/password") &&
      this.$route.query.token
    ) {
      this.currentDataType = "set_password";
    } else {
      this.currentDataType = "forgot_password";
    }
  },
  methods: {
    async sendEmailToUser(email) {
      try {
        await resetUserPassword({ email: email });
        this.currentDataType = "check_email";
      } catch (e) {
        console.error(e);
      }
    },
    async resetNewPassword(data) {
      try {
        const payload = {
          token: this.$route.query.token,
          password: data.newPass,
          password_confirm: data.confirmPass,
        };
        if (this.$route.path === "/setup/password") {
          await signupWithToken(payload);
        } else {
          await sendNewPasswordData(payload);
        }
        this.currentDataType = "password_reset";
      } catch (e) {
        console.error("e: ", e);
      }
    },
    async goToLogin() {
      await this.$router.push({ name: "LoginView" }).catch((err) => {
        if (
          VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.redirected) ||
          VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.duplicated)
        ) {
          return;
        }
        throw err;
      });
    },
  },
};
</script>
<style scoped></style>
